<template>
	<div>
		<b>Exames</b>
		<b>Campos</b>
	</div>
</template>
<script>
	import DropDraw from 'app/drop-draw';

	export default {
		components: {
			DropDraw,
		},
		props: {
			lines: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/import/components/exames-nao-importados/components/item-importation/components/options-sd2000.vue